<template>
  <div class="wlx-news-backstage-wrapper">
    <div class="yk-wrap-fixeds">
      <header class="u-school-manager-head">
        <el-form :inline="true" size="small">
          <div class="dd-search-form-news">
            <el-form-item>
              <el-input v-model="cName" placeholder="请输行业组织或者企业名称" clearable></el-input>
            </el-form-item>
            <!-- <el-form-item>
              <el-select v-model="value" placeholder="请选择岗位学历" clearable>
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-circle-plus-outline" @click="add">添加</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-delete" @click="deleteAll">删除</el-button>
            </el-form-item>
          </div>
        </el-form>
      </header>
      <!-- 新增岗位 -->
      <el-dialog
        title="新增岗位"
        v-if="addNewNoticeVisible"
        :visible.sync="addNewNoticeVisible"
        :before-close="cancel"
        :append-to-body="true"
        width="70%"
        :close-on-click-modal="false"
      >
        <div>
          <el-form ref="ruleForm" label-width="80px">
            <el-form-item label="行业领域" prop="industryField">
              <el-input v-model="industryField"></el-input>
            </el-form-item>
            <el-form-item label="学历要求" style="80px">
              <el-radio-group v-model="elevel">
                <el-radio :label="1">高职</el-radio>
                <el-radio :label="2">中职</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="企业名称" prop="companyName">
              <el-input v-model="companyName"></el-input>
            </el-form-item>
            <el-form-item label="岗位名称" prop="jobsName">
              <el-input v-model="jobsName"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="phone"></el-input>
            </el-form-item>
            <el-form-item label="需求省份" prop="needProvince">
              <el-input v-model="needProvince"></el-input>
            </el-form-item>
            <el-form-item label="需求数量" prop="needNumber">
              <el-input v-model="needNumber"></el-input>
            </el-form-item>
            <el-form-item label="岗位能力要求">
              <Editor v-model="abilityRequirements" placeholder="请输入内容"/>
            </el-form-item>
            <el-form-item label="专业要求">
              <Editor v-model="majorRequirements" placeholder="对照高职和中职专业目录填写"/>
            </el-form-item>
            <el-form-item label="备注">
              <Editor v-model="note" placeholder="请输入内容"/>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="addJobs()">确 定</el-button>
        </span>
      </el-dialog>
      <!--编辑-->
      <el-dialog
        title="编辑岗位"
        v-if="editNoticeVisible"
        :visible.sync="editNoticeVisible"
        :before-close="cancel"
        :append-to-body="true"
        width="70%"
        :close-on-click-modal="false"
      >
        <div>
          <el-form ref="ruleForm" label-width="80px">
            <el-form-item label="行业领域" prop="title">
              <el-input v-model="industryField"></el-input>
            </el-form-item>
            <el-form-item label="岗位学历要求" style="80px">
              <el-radio-group v-model="elevel">
                <el-radio :label="1">高职</el-radio>
                <el-radio :label="2">中职</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="行业组织或企业名称" prop="companyName">
              <el-input v-model="companyName"></el-input>
            </el-form-item>
            <el-form-item label="岗位名称" prop="jobsName">
              <el-input v-model="jobsName"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="phone"></el-input>
            </el-form-item>
            <el-form-item label="需求省份" prop="needProvince">
              <el-input v-model="needProvince"></el-input>
            </el-form-item>
            <el-form-item label="需求数量" prop="needNumber">
              <el-input v-model="needNumber"></el-input>
            </el-form-item>
            <el-form-item label="岗位能力要求">
              <Editor v-model="abilityRequirements" placeholder="请输入内容"/>
            </el-form-item>
            <el-form-item label="专业要求">
              <Editor v-model="majorRequirements" placeholder="对照高职和中职专业目录填写"/>
            </el-form-item>
            <el-form-item label="备注">
              <Editor v-model="note" placeholder="请输入内容"/>
            </el-form-item>
            
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="editNeedJobs()">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 查看新闻弹框 -->
      <el-dialog
        title="查看新闻"
        v-if="viewNoticeVisible"
        :visible.sync="viewNoticeVisible"
        :before-close="cancel"
        :append-to-body="true"
        width="70%"
        :close-on-click-modal="false"
      >
        <div>
          <el-form ref="ruleForm" label-width="80px" disabled>
            <el-form-item label="新闻标题" prop="title">
              <el-input v-model="title"></el-input>
            </el-form-item>
            <el-form-item label="新闻内容">
              <Editor v-model="content" placeholder="请输入内容"/>
            </el-form-item>
            <el-form-item label="新闻封面">
              <imageUpload :url="urlAliyunOSS" :files.sync="avatorUrl" format="image"></imageUpload>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="cancel">确 定</el-button>
        </span>
      </el-dialog>
      <div class="u-table-main">
        <el-table
          ref="multipleeeeTable"
          :data="list"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
        >
          <el-table-column prop="id" type="selection" width="55"></el-table-column>
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="industryField" label="行业领域" width="80"></el-table-column>
          <el-table-column prop="companyName" label="行业组织或企业名称" width="150"></el-table-column>
          <el-table-column prop="jobsName" label="岗位名称" width="80"></el-table-column>
          <el-table-column prop="needProvince" label="需求省份" width="60"></el-table-column>
          <el-table-column prop="needNumber" label="需求数量" width="50"></el-table-column>
          <el-table-column prop="newsType" label="岗位学历要求" width="60">
            <template slot-scope="scope">
              <span v-if="scope.row.elevel==1">高职</span>
              <span v-else>中职</span>
            </template>
          </el-table-column>
          <el-table-column label="岗位能力要求" :show-overflow-tooltip="true" width="300">
            <template slot-scope="scope">
              <p v-html="scope.row.abilityRequirements" class="scope-p"></p>
            </template>
          </el-table-column>
          <el-table-column label="专业要求" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <p v-html="scope.row.majorRequirements" class="scope-p"></p>
            </template>
          </el-table-column>
          <el-table-column label="备注" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <p v-html="scope.row.note" class="scope-p"></p>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="联系电话" ></el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                <el-button
                  size="mini"
                  class="el-icon-edit"
                  @click="edit(scope.row)"
                  type="primary"
                ></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                <el-button
                  size="mini"
                  type="danger"
                  class="el-icon-delete"
                  @click="deleteMajor(scope.row.id)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="news-page-con">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="onPageChangeHandler"
          :current-page="pageIndex"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          v-show="total>0"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
  data() {
    return {
      list: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      addNewNoticeVisible: false,
      editNoticeVisible: false,
      viewNoticeVisible: false,
      /* -----------添加/修改弹框参数------------ */
      sTitle: "",
      industryField: "",
      elevel: 0,
      companyName: "",
      jobsName:"",
      phone:"",
      needProvince:"",
      needNumber:"",
      abilityRequirements:"",
      majorRequirements:"",
      note:"",
      /* --------------------------------------- */
      id: "",
      ids: [],
      cName:"",
      options: [
        {
          label: "高职",
          value: 1
        },
        {
          label: "中职",
          value: 2
        }
      ],
      value: "",
      needJobsId: "",
      urlAliyunOSS: "/api/design/osssign/getsign"
    };
  },
  components: {
    imageUpload
  },
  created() {
    this.school = this.$store.state.auth.userName;
    this.getJobsList();
  },
  methods: {
    getJobsList(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/JobsNeedManager/getJobsList", {
          page: page,
          pageSize: this.pageSize,
          cName: that.cName,
          ETyoe: that.value
        })
        .then(rst => {
          if (rst.code == 1) {
            this.list = rst.list;
            this.total = rst.pagination.totalCount;
            this.pageSize = rst.pagination.pageSize;
            this.pageIndex = rst.pagination.pageIndex;
            this.cancel();
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },
    onPageChangeHandler(page) {
      this.getJobsList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getJobsList();
    },
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach(element => {
        this.ids.push(element.id);
      });
    },
    cancel() {
      (this.addNewNoticeVisible = false),
      (this.editNoticeVisible = false),
      (this.viewNoticeVisible = false),
      this.industryField= "",
      this.elevel= 0,
      this.companyName= "",
      this.jobsName="",
      this.phone="",
      this.needProvince="",
      this.needNumber="",
      this.abilityRequirements="",
      this.majorRequirements="",
      this.note=""
    },
    addJobs() {
      var that = this;
      this.$http
        .post("/api/XOrg/JobsNeedManager/addJobs", {
          industryField: that.industryField,
          elevel: that.elevel,
          companyName: that.companyName,
          jobsName: that.jobsName,
          phone: that.phone,
          needProvince: that.needProvince,
          needNumber: that.needNumber,
          abilityRequirements:that.abilityRequirements,
          majorRequirements:that.majorRequirements,
          note:that.note
        })
        .then(rst => {
          if (rst.code === 1) {
            that.cancel();
            that.$message({
              showClose: true,
              message: rst.msg,
              type: "success"
            });
            that.getJobsList();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    viewSchoolNews(row) {
      this.industryField = row.industryField;
      this.elevel = row.elevel;
      this.companyName = row.companyName;
      this.jobsName = row.jobsName;
      this.phone = row.phone;
      this.needProvince = row.needProvince;
      this.needNumber = row.needNumber;
      this.abilityRequirements = row.abilityRequirements;
      this.majorRequirements = row.majorRequirements;
      this.note = row.note;
      this.viewNoticeVisible = true;
    },
    editNeedJobs() {
      var that = this;
      debugger
      this.$http
        .post("/api/XOrg/JobsNeedManager/editJobs", {
          id: that.needJobsId,
          industryField: that.industryField,
          companyName: that.companyName,
          jobsName: that.jobsName,
          phone:that.phone,
          needProvince: that.needProvince,
          needNumber: that.needNumber,
          abilityRequirements: that.abilityRequirements,
          majorRequirements: that.majorRequirements,
          note: that.note
        })
        .then(rst => {
          if (rst.code === 1) {
            that.cancel();
            that.$message({
              message: rst.msg,
              type: "success"
            });
            that.editNoticeVisible = false;
            that.getJobsList();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    add() {
      this.addNewNoticeVisible = true;
    },
    edit(row) {
      this.editNoticeVisible = true;
      this.industryField = row.industryField;
      this.elevel = row.elevel;
      this.companyName = row.companyName;
      this.needJobsId = row.id;
      this.jobsName = row.jobsName;
      this.phone = row.phone;
      this.needProvince = row.needProvince;
      this.needNumber = row.needNumber;
      this.abilityRequirements = row.abilityRequirements;
      this.majorRequirements = row.majorRequirements;
      this.note = row.note;
    },
    deleteMajor(id) {
      this.$confirm("此操作将删除该岗位信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // this.DeleteSchoolNews(id)
          var that = this;
          this.$http
            .post("/api/XOrg/JobsNeedManager/deleteNews", {
              jobsIds: id
            })
            .then(rst => {
              if (rst.code === 1) {
                that.$message({
                  message: rst.msg,
                  type: "success"
                });
                that.getJobsList();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    search() {
      this.getJobsList(1);
    },
    deleteAll() {
      if (this.ids.length === 0) {
        this.$message({
          showClose: true,
          message: "请选择岗位信息",
          type: "warning"
        });
        return false;
      }
      this.$confirm("此操作将删除所选岗位信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // DeleteSchoolNews(this.ids)
          var that = this;
          this.$http
            .post("/api/XOrg/JobsNeedManager/deleteNews", {
              jobsIds: that.ids
            })
            .then(rst => {
              if (rst.code === 1) {
                this.$message({
                  message: rst.msg,
                  type: "success"
                });
                this.getJobsList();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>


<style lang='scss'>
.wlx-news-backstage-wrapper {
  .news-page-con {
    padding: 20px 0;
    text-align: center;
  }
  .dd-search-form-news{
      margin: 13px 0px 0 0;
  }
}
</style>
